export const OAuthApplicationsRoutes = {
	base: '/company/integrations/oauth-applications',
	new: '/company/integrations/oauth-applications/new',
	edit: (id: string) => `/company/integrations/oauth-applications/${id}/edit`,
} as const;

export const OAuthApplicationsFeatureFlag = 'oauth-application-mgmt-ui';
